(() => {
  if (customElements.get('collino-willys')) return;

  class CollinoWillys extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      const stage = this.querySelector('[data-willys-stage]');
      const range = this.querySelector('[data-willys-range]');
      const controls = this.querySelector('[data-willys-controls]');
      if (!stage || !range || !controls) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      let activePointer = null;
      const update = () => {
        const value = Math.max(0, Math.min(100, Number(range.value) || 0));
        this.style.setProperty('--willys-position', `${value}%`);
        range.setAttribute('aria-valuetext', `${range.dataset.beforeLabel}: ${value}%. ${range.dataset.afterLabel}: ${100 - value}%.`);
      };
      const updateFromPointer = (event) => {
        const rect = stage.getBoundingClientRect();
        if (!rect.width) return;
        range.value = String(Math.round(Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100))));
        update();
      };
      range.addEventListener('input', update, options);
      stage.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        activePointer = event.pointerId;
        stage.setPointerCapture(activePointer);
        range.focus({ preventScroll: true });
        updateFromPointer(event);
      }, options);
      stage.addEventListener('pointermove', (event) => {
        if (event.pointerId === activePointer) updateFromPointer(event);
      }, options);
      const release = (event) => {
        if (event.pointerId !== activePointer) return;
        if (stage.hasPointerCapture(activePointer)) stage.releasePointerCapture(activePointer);
        activePointer = null;
      };
      stage.addEventListener('pointerup', release, options);
      stage.addEventListener('pointercancel', release, options);
      stage.addEventListener('lostpointercapture', () => { activePointer = null; }, options);
      update();
      controls.hidden = false;
      this.dataset.initialized = 'true';
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      delete this.dataset.initialized;
      const controls = this.querySelector('[data-willys-controls]');
      if (controls) controls.hidden = true;
    }
  }

  // Custom element lifecycle handles Shopify section load/unload automatically.
  customElements.define('collino-willys', CollinoWillys);
})();
